var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDoubleBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33683 0.396233L7.23576 3.29562C7.5463 3.60616 7.32658 4.13699 6.88786 4.13699H1.08854C0.649818 4.13699 0.430092 3.60616 0.739906 3.29562L3.63956 0.396233C3.83219 0.203697 4.1442 0.203697 4.33683 0.396233ZM3.66154 10.6039L0.761879 7.70443C0.452065 7.39397 0.671791 6.86315 1.11051 6.86315H6.90983C7.34855 6.86315 7.56828 7.39397 7.25773 7.70443L4.3588 10.6039C4.16618 10.7963 3.85416 10.7963 3.66154 10.6039Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDoubleBlack);
export default __webpack_public_path__ + "static/media/caretDoubleBlack.9131202c6b2fe094b880f30af7bb2e4c.svg";
export { ForwardRef as ReactComponent };